// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3o2pQ","tabsBox":"styles_tabsBox__1bvUw","createButton":"styles_createButton__19cJV"};